export const PROFILE_AVATAR_MAX_BYTES = 2 * 1024 * 1024;

export const PROFILE_AVATAR_ACCEPT = "image/jpeg,image/png,image/webp";

export const PROFILE_AVATAR_ALLOWED_TYPES = new Set(["image/jpeg", "image/png", "image/webp"]);
